import type { Move } from '../../../schemas/move';

/**
 * ***Adepto Multiclasse*** — mossa comune oltre il 10° livello (manuale V1
 * rr. 1799-1803). Richiede *Apprendista Multiclasse*.
 *
 * Effetto: scegli una mossa **iniziale** o **avanzata di livello 2-5** di
 * un'altra classe. Non prendere mosse multiclasse.
 *
 * Strutturazione (D10 / FI-11):
 *  - `multiclass.levelAdjustment.delta: -5` (PG Instancabile L10 →
 *    livello effettivo L5 per scegliere la mossa-target; pool include
 *    starting + advanced_2_5)
 *  - Filtro `tags: ['multiclasse']` nativo FI-17.
 */
export const adeptoMulticlasse: Move = {
  id: 'common.adepto-multiclasse',
  name: 'Adepto Multiclasse',
  type: 'common',
  trigger: 'Quando prendi questa mossa al level-up (oltre il 10° livello)',
  description:
    "Scegli una mossa iniziale o una avanzata di livello 2-5 da un'altra classe. Non prendere mosse multiclasse.",
  tags: ['multiclasse'],
  prerequisites: ['common.apprendista-multiclasse'],
  replaces: [],
  multiclass: {
    picks: { kind: 'any-other-class' },
    levelAdjustment: { delta: -5 },
  },
};
